export default class NoticeModal {
    constructor() {
        this.init();
    }

    init() {
        this.eventBind();
    }

    eventBind() {
        const closebtn = document.querySelector(".js-noticemodalclose");

        closebtn.addEventListener("click", () => {
            document.querySelector(".noticemodal").classList.remove("-active");
            document.body.classList.remove("-inmodal");
        });
    }
}
